module.exports = __webpack_public_path__ + "static/media/new-york-44.6b3f4ca9.jpg";